import React, { useState } from "react";
import { MultistepProgress } from "../../Utility/MultistepProgress";
import { FaPen, FaPlaneDeparture, FaScroll } from "react-icons/fa";
import SimpleTransitionBoth from "../../Utility/SimpleTransitionBoth";
import { MultistepIcon } from "../../Utility/MultistepIcon";
import { BsCardList, BsDownload, BsJournalText } from "react-icons/bs";
import { TbArrowUpRight, TbArrowsDiagonal } from "react-icons/tb";
import { CDKAlertNote } from "./CDKAlertNote";
import { useEffect } from "react";
import {
  cdkSubscriptionStatuses,
  docLinks,
  emails,
  pages,
  pdfLinks,
} from "../../../constants";
import { isEmpty } from "lodash";
import { useHistory } from "react-router-dom";
import { DiliTextCP } from "../../Utility/DiliTextCP";
import { TermsAgreementScroller } from "../../Utility/TermsAgreementScroller";
import handleApiError from "../../../helpers/handleApiError";
// import { getProfileInformation } from "../../../services/accountService";
import {
  acceptCDKAgreement,
  getCDKSubscriptionStatus,
  setSubscriptionPending,
} from "../../../services/cdkOrderService";
import { LoadingSpinner } from "../../Utility/LoadingSpinner";
import {
  openInNewTab,
  sleep,
  prependBasePath,
  determineHasAccessToCDKFeatures,
} from "../../../helpers/utilities";
import { CDKAlertNote2 } from "./CDKAlertNote2";
import { CDKIntegrationPackageDisplay } from "./CDKIntegrationPackageDisplay";
import { LicenseAgreement } from "../CDKLicenseAgreement";
import { HelmetUtil } from "../../Utility/HelmetUtil";
import { DiliCheckboxCP } from "../../Utility/DiliCheckboxCP";
import FortellisMarketplaceActivateImg from "../../../assets/images/Diligent Fortellis Marketplace Listing.png";
import AccordionCard from "../../AccordionCard";

const CDKInstructions = () => {
  return (
    <>
      <CDKAlertNote2
        // color="white"
        // color="rgb(240,240,240)"
        message="Remember, the Diligent CDK Integration is for those who are using CDK for their parts sales."
      />
      <div className="py-5 px-3">
        {/* What you'll need. <br /> You will need your CDK Dealer ID, estoreurl,
        can contact CDK estore help option 8 for help in placing order on their
        site. */}
        <div className="mb-3">An overview of the registration process:</div>
        <ol className="cdk-instruction-list list-style-none">
          <li>1. Fill out a short form.</li>
          <li>2. Read and agree to the End-User License Agreement.</li>
          <li>
            3. Final steps of the CDK Integration signup process will need to be
            completed through our Fortellis Marketplace Integration Link. A
            detailed guide will be provided on the final step, but the process
            involves:
            <ol type="I" className="list-style-none">
              <li>
                I. Clicking on the link to our Fortellis Marketplace Integration
                Listing found on the last step.
                <CDKIntegrationPackageDisplay />
              </li>
              <li>
                II. Clicking Activate on our listing which will take you to the
                ConnectCDK website.
              </li>
              <li>
                III. Once there you can login using your CDK Dealer Suite
                credentials if needed and go through a quick setup form for our
                integration.
              </li>
              <li>
                IV. At which point, you'll be all set. We will verify and enable
                your CDK Integration within five business days.
              </li>
            </ol>
          </li>
        </ol>
      </div>
    </>
  );
};

const CDKRegistrationForm = ({
  cdkDealerIDValue,
  handleChangeCDKDealerIDValue,
}) => {
  return (
    <div>
      1. Registration Form
      <DiliTextCP
        label="CDK Dealer Suite Username/Email"
        className="py-4"
        value={cdkDealerIDValue}
        maxLength={60}
        onChange={handleChangeCDKDealerIDValue}
        placeholder="Enter your CDK Dealer Suite Username/Email"
      />
    </div>
  );
};
const CDKTermsAndConditions = ({
  onScrolledToEnd,
  onScrolledAwayFromEnd,
  agreementFormData,
  handleChangeAgreementFormData,
  scrolledToEnd,
}) => {
  return (
    <div>
      2. Read and agree to the End-User License Agreement (EULA).
      <button
        type="button"
        className="btn btn-primary d-flex align-items-center ml-auto my-3"
        onClick={() => {
          openInNewTab(prependBasePath(docLinks.CDKEULA));
        }}
      >
        <BsDownload style={{ marginRight: "10px" }} />
        Download
      </button>
      <TermsAgreementScroller
        prependBasePath={true}
        onScrolledToEnd={onScrolledToEnd}
        onScrolledAwayFromEnd={onScrolledAwayFromEnd}
        // doOnce={true}
        // fileURL={docLinks.CDKEULA} //Not currently working
        html={<LicenseAgreement />} //Please remember to update the html if the document/pdf changes.
        heading={
          <>
            DILIGENT DELIVERY SYSTEMS
            <br />
            PARTS DELIVERY LOGISTICS INTEGRATOR
            <sup>TM</sup>
            <br />
            END-USER LICENSE AND AGREEMENT
          </>
        }
        headingStyle={
          {
            // width: "50%",
          }
        }
      />
      <div className="py-2">
        <p className="text-center p-2">
          Please scroll to the end of the EULA to be able to eSign and submit.
        </p>
        <DiliTextCP
          disabled={!scrolledToEnd}
          name="fullName"
          value={agreementFormData.fullName}
          onChange={handleChangeAgreementFormData}
          label="Full Name"
          className="pb-2"
          placeholder="Enter your full name"
        />
        <DiliTextCP
          disabled={!scrolledToEnd}
          name="title"
          value={agreementFormData.title}
          onChange={handleChangeAgreementFormData}
          label="Title"
          placeholder="Enter your company title"
        />
        <DiliCheckboxCP
          disabled={!scrolledToEnd}
          name="agree"
          checked={agreementFormData.agree}
          onChange={handleChangeAgreementFormData}
          type="checkbox"
          label="I have read and agree to the EULA."
          containerClassAppend="my-2 text-right"
        />
      </div>
    </div>
  );
};

const CDKeStoreInstructions = ({
  cdkSubscriptionStatus,
  justFinishedApplication,
  history,
}) => {
  const handleClickClose = () => {
    history.push(pages.orderHistory.url);
    history.go(0); //Refresh after pushing to order history so that the site refetches their cdk subscription status for use in the various cdk pages' redirection logic and navbar. Maybe not ideal, but it works for now.
  };
  return (
    <div>
      {cdkSubscriptionStatus === cdkSubscriptionStatuses.pending &&
        !justFinishedApplication && (
          <div className="info-display-bordered text-center mt-3 mb-3">
            <span className="font-600">Status: {cdkSubscriptionStatus}</span>
            <br />
            Once the below step is completed, please allow five business days
            for processing of your application.
          </div>
        )}
      <CDKAlertNote2
        // color="white"
        message={
          <>
            To ensure your CDK Integration can be enabled, you{" "}
            <span className="font-600">MUST</span> finish the following step.
          </>
        }
        containerStyleMerge={{ marginBottom: "20px" }}
      />
      <div className="mb-2">3. CDK Fortellis Marketplace Guide</div>
      <CDKIntegrationPackageDisplay />
      <span className="text-danger font-600">
        To finish enrolling, please use our Fortellis Marketplace link below.
      </span>
      <br />
      You will need to click the activate button on our Fortellis Marketplace
      listing, which will redirect you to ConnectCDK where you will need to log
      in using your CDK Dealer Suite credentials and go through a short signup
      form. If you need assistance, see the detailed guide below.
      <div className="pt-4">
        <u>Fortellis Marketplace Listing:</u>
        <br />
        <a
          target="_blank"
          rel="noopener noreferrer"
          style={{ wordBreak: "break-all" }}
          href="https://marketplace.fortellis.io/solutions/diligent-delivery-systems/diligent-delivery-systems?id=586ce2af-0a28-47b0-880a-4512e9a9d4eb"
        >
          https://marketplace.fortellis.io/solutions/diligent-delivery-systems/diligent-delivery-systems?id=586ce2af-0a28-47b0-880a-4512e9a9d4eb
        </a>
      </div>
      <br />
      Once you are done there, we will review and process your application
      within 5 business days!
      <div className="pt-5">
        <AccordionCard
          title="Detailed Guide"
          showByDefault={false}
          eventKey="detailedGuide"
        >
          <div className="py-2">
            <div className="font-600 mt-4 mb-1">
              A detailed guide of the CDK enrollment process:
            </div>
            <ol className="cdk-instruction-list list-style-none ml-3">
              <li>
                1. Once you visit our CDK Fortellis Marketplace listing using
                the link above, you will need to click activate.
                <img
                  style={{ width: "100%" }}
                  src={FortellisMarketplaceActivateImg}
                />
              </li>
              <li>
                2. You will be redirected to the ConnectCDK login page. Log in
                using your CDK credentials.
              </li>
              <li>
                3. A short signup form will appear.
                <ol type="I" className="">
                  <li>
                    Select which of your dealership locations you wish to
                    include in the integration. If you have multiple
                    sub-accounts for a dealership, you may want to confirm you
                    pick the right one for each location under the CMF Number
                    column.
                  </li>
                  <li>Review and agree to the terms and agreements shown.</li>
                  <li>
                    You may be asked to select which DMS account to apply this
                    integration for. Select the appropriate one.
                  </li>
                  <li>
                    Review the activation details and{" "}
                    <strong>press Complete Activation.</strong>
                  </li>
                </ol>
              </li>

              <li>
                4. We will review and process your application within 5 business
                days!
              </li>
            </ol>
            <CDKAlertNote2
              // color="white"
              message={
                <>
                  If you have trouble during this step, you can watch the video
                  guide{" "}
                  <a
                    style={{
                      color: "white",
                      fontWeight: 600,
                      textDecoration: "underline",
                    }}
                    href="https://cdkglobal.wistia.com/medias/05rn36sghz"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    here
                  </a>
                  . If you still cannot continue, contact us at{" "}
                  {emails.supportEmail} for assistance.
                </>
              }
              containerStyleMerge={{ marginBottom: "20px", marginTop: "20px" }}
            />
          </div>
        </AccordionCard>
      </div>
      <button
        className="btn btn-primary float-right"
        onClick={handleClickClose}
      >
        Close
      </button>
    </div>
  );
};

const maxSteps = 4;

const cdkSteps = {
  instructions: 0,
  registrationForm: 1,
  termsAgreement: 2,
  eStoreGuide: 3,
};

export const CDKSignupPage2 = ({
  decodedJWT,
  cdkSubscriptionStatus,
  setCDKSubscriptionStatus,
}) => {
  const history = useHistory();
  const [currentStep, setCurrentStep] = useState(0);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (determineHasAccessToCDKFeatures(cdkSubscriptionStatus)) {
      history.replace(pages.cdkOrderImport.url);
    }
    if (cdkSubscriptionStatus === cdkSubscriptionStatuses.pending) {
      setCurrentStep(cdkSteps.eStoreGuide);
    }
    // if (!isEmpty(decodedJWT) && decodedJWT.IsCdkClient) {
    //   history.push(pages.cdkOrderImport.url);
    // }
    // const checkStatus = async () => {
    //   const statusResponse = await getCDKSubscriptionStatus();
    //   // console.log(statusResponse);
    //   if (statusResponse.data) {
    //     if (statusResponse.data === cdkSubscriptionStatuses.active) {
    //       //if they are active, push them to cdk order import
    //       // console.log("Pushing to: ", pages.cdkSubscription.url);
    //       history.push(pages.cdkOrderImport.url);
    //     }
    //   }
    // };
    // checkStatus();
  }, [decodedJWT, cdkSubscriptionStatus]);

  const [submittingCDKRequest, setSubmittingCDKRequest] = useState(false);
  const [errorDuringSubmission, setErrorDuringSubmission] = useState();
  const [justFinishedApplication, setJustFinishedApplication] = useState(false);
  const handleClickNext = async () => {
    if (currentStep === cdkSteps.termsAgreement) {
      try {
        setSubmittingCDKRequest(true);
        await sleep(1000); // just for less jarring loading visual on fast internet speeds.
        const agreementResponse = await acceptCDKAgreement(
          agreementFormData.title,
          agreementFormData.fullName,
          agreementFormData.agree,
          ""
        );
        const response = await setSubscriptionPending(cdkDealerIDValue);
        setCDKSubscriptionStatus(cdkSubscriptionStatuses.pending);
        setJustFinishedApplication(true);

        if (errorDuringSubmission) {
          setErrorDuringSubmission(false);
        }
      } catch (ex) {
        handleApiError(ex, history);
        setErrorDuringSubmission(true);
        return;
      } finally {
        setSubmittingCDKRequest(false);
      }
    }
    setCurrentStep((prev) => {
      if (prev < maxSteps - 1) {
        return prev + 1;
      } else {
        return prev;
      }
    });
  };

  const handleClickPrevious = () => {
    setCurrentStep((prev) => {
      if (prev > 0) {
        return prev - 1;
      } else {
        return prev;
      }
    });
  };
  const handleClickBack = () => {
    history.goBack();
  };

  const [scrolledToEnd, setScrolledToEnd] = useState(false);
  const handleScrolledToEnd = () => {
    setScrolledToEnd(true);
  };

  const [agreementFormData, setAgreementFormData] = useState({
    title: "",
    fullName: "",
    agree: false,
  });

  const handleChangeAgreementFormData = (e) => {
    setAgreementFormData({
      ...agreementFormData,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };

  const handleScrolledAwayFromEnd = () => {
    setScrolledToEnd(false);
  };

  const [cdkDealerIDValue, setCDKDealerIDValue] = useState("");
  const handleChangeCDKDealerIDValue = (e) => {
    setCDKDealerIDValue(e.target.value);
  };

  return (
    <>
      <HelmetUtil title="CDK Sign Up" />
      <SimpleTransitionBoth
        transitionBaseStyle={{ opacity: 0 }}
        transitionEndStyle={{ opacity: 1 }}
        duration="1s"
      >
        <div
          className="p-2 p-md-5 remove-global-padding text-17"
          style={{ minHeight: "100vh", position: "relative" }}
        >
          {/* <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1,
          }}
          className="bg-dil-diag"
        ></div> */}
          <div
            className="container paper-panel p-3 p-md-5"
            style={{
              backgroundColor: "white",
              position: "relative",
              zIndex: 1,
            }}
          >
            <SimpleTransitionBoth
              delay={400}
              duration="1s"
              transitionBaseStyle={{
                opacity: 0,
                transform: "translateY(30px)",
              }}
              transitionEndStyle={{ opacity: 1, transform: "translateY(0px)" }}
            >
              <div
                style={{
                  backgroundColor: "#ef3e42",
                  // width: "fit-content",
                  margin: "auto",
                  // transform: "skew(-30deg)",
                }}
                className="px-5 mb-4"
              >
                <h1
                  className="text-light text-center py-3"
                  style={{
                    letterSpacing: "3px",
                    // transform: "skew(30deg)",

                    // textDecoration: "underline #ef3e42 5px",
                  }}
                >
                  CDK Signup
                </h1>
              </div>
            </SimpleTransitionBoth>
            <SimpleTransitionBoth
              delay={1200}
              duration="1s"
              transitionBaseStyle={{
                opacity: 0,
                transform: "translateY(-30px)",
              }}
              transitionEndStyle={{ opacity: 1, transform: "translateY(0px)" }}
            >
              <MultistepProgress
                containerStyle={{ marginBottom: "30px" }}
                currentStep={currentStep}
                incompleteColor="rgb(210,210,210)"
                steps={[
                  <MultistepIcon
                    size="3.5rem"
                    gap={30}
                    icon={<BsCardList size="1.7rem" />}
                    label={<div>Instructions</div>}
                  />,
                  <MultistepIcon
                    size="3.5rem"
                    gap={30}
                    icon={<FaPen size="1.5rem" />}
                    label={<div>Form</div>}
                  />,
                  <MultistepIcon
                    size="3.5rem"
                    gap={30}
                    icon={<FaScroll size="1.9rem" />}
                    label={<div>License Agreement</div>}
                  />,
                  <MultistepIcon
                    size="3.5rem"
                    gap={30}
                    icon={
                      <TbArrowUpRight
                        // FaPlaneDeparture
                        size="2rem"
                      />
                    }
                    label={<div>Final Steps</div>}
                  />,
                  // <div
                  //   style={{
                  //     backgroundColor: stepLabelColor,
                  //     display: "grid",
                  //     placeContent: "center",
                  //     justifyContent: "center",
                  //     alignContent: "center",
                  //     color: "white",
                  //     alignItems: "center",
                  //     border: "2px solid white",
                  //     borderRadius: "100%",
                  //     aspectRatio: "1/1",
                  //     padding: "1rem",
                  //     margin: ".3rem",
                  //   }}
                  // >
                  //   <FaScroll
                  //     size="2rem"
                  //     style={{
                  //       // backgroundColor: "green",
                  //       margin: "auto",
                  //     }}
                  //   />
                  //   <div
                  //     style={
                  //       {
                  //         // backgroundColor: "yellow"
                  //       }
                  //     }
                  //   >
                  //     Instructions
                  //   </div>
                  // </div>,
                ]}
              />
            </SimpleTransitionBoth>
            <SimpleTransitionBoth
              delay={1200}
              duration="1s"
              transitionBaseStyle={{
                opacity: 0,
                transform: "translateY(60px)",
              }}
              transitionEndStyle={{
                opacity: 1,
                transform: "translateY(0px)",
              }}
            >
              <div className="py-4">
                {currentStep === cdkSteps.instructions && <CDKInstructions />}
                {currentStep === cdkSteps.registrationForm && (
                  <CDKRegistrationForm
                    cdkDealerIDValue={cdkDealerIDValue}
                    handleChangeCDKDealerIDValue={handleChangeCDKDealerIDValue}
                  />
                )}
                {currentStep === cdkSteps.termsAgreement &&
                  (submittingCDKRequest ? (
                    <div
                      style={{
                        display: "grid",
                        placeContent: "center",
                        height: "50vh",
                      }}
                    >
                      <LoadingSpinner title={"Please Wait..."} />
                    </div>
                  ) : (
                    <CDKTermsAndConditions
                      onScrolledToEnd={handleScrolledToEnd}
                      onScrolledAwayFromEnd={handleScrolledAwayFromEnd}
                      agreementFormData={agreementFormData}
                      handleChangeAgreementFormData={
                        handleChangeAgreementFormData
                      }
                      scrolledToEnd={scrolledToEnd}
                    />
                  ))}
                {currentStep === cdkSteps.eStoreGuide && (
                  <CDKeStoreInstructions
                    cdkSubscriptionStatus={cdkSubscriptionStatus}
                    justFinishedApplication={justFinishedApplication}
                    history={history}
                  />
                )}
              </div>
            </SimpleTransitionBoth>
            <SimpleTransitionBoth
              delay={1200}
              duration="1s"
              transitionBaseStyle={{ opacity: 0 }}
              transitionEndStyle={{ opacity: 1 }}
            >
              {currentStep < 3 && (
                <div className="d-flex justify-content-between align-items-center">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={
                      currentStep === cdkSteps.instructions
                        ? handleClickBack
                        : handleClickPrevious
                    }
                  >
                    {currentStep === cdkSteps.instructions
                      ? "Back"
                      : "Previous"}
                  </button>

                  <button
                    disabled={
                      (currentStep === cdkSteps.registrationForm &&
                        cdkDealerIDValue.length < 3) ||
                      (currentStep === cdkSteps.termsAgreement &&
                        (!scrolledToEnd ||
                          !agreementFormData.agree ||
                          agreementFormData.fullName.length < 4 ||
                          agreementFormData.title.length < 2))
                    }
                    type="button"
                    className="btn btn-primary"
                    onClick={handleClickNext}
                  >
                    {currentStep === cdkSteps.termsAgreement
                      ? "Submit"
                      : "Next"}
                  </button>
                </div>
              )}
            </SimpleTransitionBoth>
          </div>
        </div>
      </SimpleTransitionBoth>
    </>
  );
};
